export class MyNotifications {
    id: string;
    sender: string;
    receiver: string;
    event: string;
    isSeen: boolean;
    detail: any | null;
    timestamp: Date;
  
    constructor(
      id: string,
      sender: string,
      receiver: string,
      event: string,
      isSeen: boolean,
      detail: any | null,
      timestamp: Date ,
    ) {
      this.id = id;
      this.sender = sender;
      this.receiver = receiver;
      this.event = event;
      this.isSeen = isSeen;
      this.detail = detail;
      this.timestamp = timestamp;
    }
  }
  